import { exportTabReducerKey, chemQuoteExportTabReducerKey } from './ExportTabConstants';

const createSelectors = (reducerKey) => {
  const exportTab = (state) => state.get(reducerKey);

  const exportType = (state) => exportTab(state).get('exportType');

  const exportResult = (state) => exportTab(state).get('exportResult');

  const retryDisabled = (state) => exportTab(state).get('retryDisabled');

  const downloadUrl = (state) => exportTab(state).get('downloadUrl');

  const tooltipModalOpened = (state) => exportTab(state).get('tooltipModalOpened');

  const cancelledJobIds = (state) => exportTab(state).get('cancelledJobIds');

  return {
    exportTab,
    exportResult,
    exportType,
    retryDisabled,
    downloadUrl,
    tooltipModalOpened,
    cancelledJobIds,
  };
};

export const exportTabSelectors = createSelectors(exportTabReducerKey);
export const chemquoteExportTabSelectors = createSelectors(chemQuoteExportTabReducerKey);
